// extracted by mini-css-extract-plugin
export default {"banner":"index_banner_rPlpq","bannerFix":"index_bannerFix_NyEAg"};